<div class="mat-dialog-content">
    <label>{{'aumico_notes_super_table_segment_title' | i18next}}</label>
    <div class="segment-input">
        <input
            hamInput
            placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [formControl]="form.controls['title']"
        />

        <span *ngIf="form.controls['title'].touched && form.controls['title'].invalid">
            {{ 'aumico_annual_report_mandatory_field_error' | i18next }}
        </span>
    </div>
    <div class="segment-selection">
        <label>{{'aumico_notes_super_table_segmented_columns' | i18next}}</label>
        <input
            hamSimpleDropDown
            [selectedOptions]="initialSelectedColumns"
            [options]="columnSelectionOptions"
            [optionKeys]="['name']"
            returnKey="id"
            readonly
            [returnObject]="true"
            placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [multiple]="true"
            [formControl]="form.controls['columns']"
            [draggable]="true"
        />
    </div>
</div>
